// @flow
import { handleResponseOld, makeGet, makePost } from './helpers';

const transformResponse = response => {
    if (!response || !response.payload || !response.payload.previews) {
        return { data: {} };
    }

    const catalogPreviews = Object.keys(response.payload.previews).map(id => {
        const {
            catalogId,
            countryCode,
            description,
            houseId: sellerId,
            imagePath,
            lastModified,
            manuallyRemoved,
            previewId,
            saleStart: saleStartTs,
            title,
        } = response.payload.previews[id];

        return {
            catalogId,
            countryCode,
            description,
            imagePath,
            lastModified,
            manuallyRemoved,
            previewId,
            saleStartTs,
            sellerId,
            title,
        };
    });

    return {
        data: {
            catalogPreviews,
        },
    };
};

type FetchSellerEndedCatalogsByIdParams = {
    authToken: string,
    count: number,
    deployment: string,
    page: number,
    sellerId: number,
    sortTerm: string,
};

type FetchSellerPreviewCatalogsByIdParams = {
    authToken: string,
    deployment: string,
    sellerId: number,
};

type FetchSellerUpcomingCatalogsByIdParams = {
    authToken: string,
    deployment: string,
    sellerId: number,
};

export default {
    fetchSellerEndedCatalogsById: ({
        authToken,
        count,
        deployment,
        page,
        sellerId,
        sortTerm,
    }: FetchSellerEndedCatalogsByIdParams) =>
        new Promise<any>((resolve, reject) => {
            const query = {};
            const request = makeGet({ authToken, deployment, path: `<ITEM-API>spa/small/seller/${sellerId}/recent` });
            if (global.__SERVER__) {
                query.pageSize = count;
                query.cursor = (page - 1) * count;
                query.sortTerm = sortTerm;
            }
            request.query(query);
            request.end((err, response) => handleResponseOld({ err, reject, resolve, response }));
        }),
    fetchSellerPreviewCatalogsById: ({ authToken, deployment, sellerId }: FetchSellerPreviewCatalogsByIdParams) =>
        new Promise<any>((resolve, reject) => {
            const request = makePost({ apiPath: 'previews', authToken, deployment, path: '<CATALOG-PREVIEWS-API>' });
            request.send({ houseId: sellerId });
            request.end((err, response) =>
                handleResponseOld({
                    err,
                    reject,
                    resolve,
                    response: response,
                    transform: transformResponse,
                })
            );
        }),
    fetchSellerUpcomingCatalogsById: ({ authToken, deployment, sellerId }: FetchSellerUpcomingCatalogsByIdParams) =>
        new Promise<any>((resolve, reject) => {
            const request = makeGet({ authToken, deployment, path: `<ITEM-API>spa/small/seller/${sellerId}/upcoming` });
            request.end((err, response) => handleResponseOld({ err, reject, resolve, response }));
        }),
};
